import React, { useState, useEffect } from "react";
import { Modal, ModalBody, ModalFooter, FormGroup, Input } from "reactstrap";
import MaskedInput from "react-text-mask";
import { toast } from "react-toastify";
import requestApi from "../../../../apirest";
import "./pos-modal.css";

export default function CustomerModal({
  isOpen,
  onClose,
  customer,
  onSelectCustomer,
  onUpdateCustomer,
  onUpdateCustomerPhone,
  onUpdateCustomerCpf,
}) {
  const [customerSearch, setCustomerSearch] = useState("");
  const [customerResults, setCustomerResults] = useState([]);
  const [newCustomerMode, setNewCustomerMode] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setCustomerSearch("");
      setCustomerResults([]);
      setNewCustomerMode(false);
    }
  }, [isOpen]);

  const searchCustomer = async () => {
    if (!customerSearch.trim()) return;
    try {
      const res = await requestApi(
        `/order/findByCustomer`,
        { search: customerSearch },
        "get",
        "order",
      );
      const data = res.data.orders || [];
      if (!data.length) {
        toast.warning("Nenhum cliente encontrado.");
        return;
      }
      setCustomerResults(data);
    } catch {
      toast.error("Erro ao buscar cliente.");
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="md" className="pos-modal">
      <div className="modal-header">
        <span className="modal-title">
          {newCustomerMode ? "Novo Cliente" : "Buscar Cliente"}
        </span>
        <button className="pos-modal-close-btn" onClick={onClose}>×</button>
      </div>

      <ModalBody>
        {!newCustomerMode ? (
          <>
            <FormGroup className="mb-3">
              <label className="pos-modal-label">Nome ou CPF</label>
              <div style={{ display: "flex", gap: 8 }}>
                <Input
                  type="text"
                  placeholder="Digite nome ou CPF"
                  value={customerSearch}
                  onChange={(e) => setCustomerSearch(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") searchCustomer();
                  }}
                  className="pos-modal-input"
                />
                <button
                  className="pos-modal-btn pos-modal-btn--primary"
                  onClick={searchCustomer}
                >
                  Buscar
                </button>
              </div>
            </FormGroup>

            {customerResults.map((r, i) => (
              <div
                key={i}
                className="pos-customer-result"
                onClick={() => onSelectCustomer(r)}
              >
                <strong>{r.customer?.name}</strong>
                <span>{r.customer?.email}</span>
                <span>{r.customer?.phone_numbers?.[0]}</span>
              </div>
            ))}

            <button
              className="pos-modal-link-btn"
              onClick={() => setNewCustomerMode(true)}
            >
              + Novo cliente
            </button>
          </>
        ) : (
          <>
            <FormGroup className="mb-3">
              <label className="pos-modal-label">Nome</label>
              <Input
                type="text"
                value={customer.name}
                onChange={(e) => onUpdateCustomer("name", e.target.value)}
                className="pos-modal-input"
              />
            </FormGroup>

            <FormGroup className="mb-3">
              <label className="pos-modal-label">E-mail</label>
              <Input
                type="email"
                value={customer.email}
                onChange={(e) => onUpdateCustomer("email", e.target.value)}
                className="pos-modal-input"
              />
            </FormGroup>

            <FormGroup className="mb-3">
              <label className="pos-modal-label">Celular</label>
              <MaskedInput
                mask={[
                  "(",
                  /[1-9]/,
                  /\d/,
                  ")",
                  " ",
                  /\d/,
                  " ",
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  "-",
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                ]}
                className="form-control pos-modal-input"
                value={customer.phone_numbers[0]}
                placeholder="(00) 0 0000-0000"
                onChange={(e) => onUpdateCustomerPhone(e.target.value)}
              />
            </FormGroup>

            <FormGroup className="mb-3">
              <label className="pos-modal-label">CPF</label>
              <Input
                type="text"
                placeholder="000.000.000-00"
                value={customer.documents[0].number}
                onChange={(e) => onUpdateCustomerCpf(e.target.value)}
                className="pos-modal-input"
              />
            </FormGroup>

            <button
              className="pos-modal-link-btn"
              onClick={() => setNewCustomerMode(false)}
            >
              ← Voltar à busca
            </button>
          </>
        )}
      </ModalBody>

      <ModalFooter>
        <button
          className="pos-modal-btn pos-modal-btn--primary"
          onClick={onClose}
        >
          Fechar
        </button>
      </ModalFooter>
    </Modal>
  );
}
